<script>
  import { format } from 'svelte-i18n';
  import { Button, ButtonGroup, Tooltip } from '@sveltestrap/sveltestrap';

  import { appStore } from '@client/stores/app';

  export let onChange = () => {};
  export let renderCardLayout = false;
  export let iconCards = 'os-icon-grid';
  export let iconOther = 'os-icon-menu';
  export let hideOnMobile = true;

  const updateUserLayout = (which) => {
    renderCardLayout = !!which;
    onChange(renderCardLayout);
  };
</script>

{#if !$appStore.mobile || ($appStore.mobile && !hideOnMobile)}
  <div class="display-options">
    <ButtonGroup size="sm">
      <Button id="user-layout-cards" active={renderCardLayout} on:click={() => updateUserLayout(true)}>
        <i class={iconCards} />
        <span class="visually-hidden">{$format('label.LAYOUT_CONTROLS_CARDS')}</span>
      </Button>
      <Tooltip target="user-layout-cards">
        {$format('label.LAYOUT_CONTROLS_CARDS')}
      </Tooltip>
      <Button id="user-layout-list" active={!renderCardLayout} on:click={() => updateUserLayout()}>
        <i class={iconOther} />
        <span class="visually-hidden">{$format('label.LAYOUT_CONTROLS_LIST')}</span>
      </Button>
      <Tooltip target="user-layout-list">
        {$format('label.LAYOUT_CONTROLS_LIST')}
      </Tooltip>
    </ButtonGroup>
  </div>
{/if}

<style lang="scss" src="./layout-controls.scss"></style>
